/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style5 = require('antd/lib/button/style');

var _button = require('antd/lib/button');

var _button2 = _interopRequireDefault(_button);

var _style6 = require('antd/lib/icon/style');

var _icon = require('antd/lib/icon');

var _icon2 = _interopRequireDefault(_icon);

var _style7 = require('antd/lib/input/style');

var _input = require('antd/lib/input');

var _input2 = _interopRequireDefault(_input);

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _style8 = require('antd/lib/form/style');

var _form = require('antd/lib/form');

var _form2 = _interopRequireDefault(_form);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormItem = _form2.default.Item;

var Search = function (_Component) {
  (0, _inherits3.default)(Search, _Component);

  function Search(props, context) {
    (0, _classCallCheck3.default)(this, Search);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Search.__proto__ || (0, _getPrototypeOf2.default)(Search)).call(this, props, context));

    _this.search = function (e) {
      e.preventDefault();
      var _this$props = _this.props,
          form = _this$props.form,
          search = _this$props.search;

      _this.props.form.validateFields(function (err, values) {
        if (!err) {
          search(values);
        }
      });
    };

    return _this;
  }

  (0, _createClass3.default)(Search, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          form = _props.form,
          onSubmit = _props.onSubmit,
          deviceNo = _props.deviceNo,
          product = _props.product;
      var getFieldDecorator = form.getFieldDecorator;

      return (0, _jsx3.default)(_form2.default, {
        layout: 'inline',
        onSubmit: this.search
      }, void 0, (0, _jsx3.default)(FormItem, {}, void 0, getFieldDecorator('keyWord', {
        initialValue: deviceNo,
        validateTrigger: ['onChange', 'onBlur'],
        rules: [{ required: false, message: '请输入查询条件' }]
      })((0, _jsx3.default)(_input2.default, {
        style: { width: 250 },
        prefix: (0, _jsx3.default)(_icon2.default, {
          type: 'search',
          style: { fontSize: 13 }
        }),
        placeholder: '\u8BBE\u5907ID/VIN\u7801/SN\u7801/\u7ED1\u5B9A\u624B\u673A\u53F7/\u94A2\u67B6\u53F7'
      }))), (0, _jsx3.default)(FormItem, {}, void 0, (0, _jsx3.default)(_button2.default, {
        onClick: this.search,
        className: 'search-btn'
      }, void 0, '\u641C\u7D22')));
    }
  }]);
  return Search;
}(_react.Component);

var SearchForm = _form2.default.create()(Search);

exports.default = SearchForm;

/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "index.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


//////////////////
// WEBPACK FOOTER
// ./src/containers/device/list/search/index.jsx
// module id = 939
// module chunks = 0